export type SessionMode = 'idle_timeout' | 'stay_logged_in' | 'session_only';

export const DEFAULT_SESSION_MODE: SessionMode = 'idle_timeout';
export const SESSION_MODE_KEY = 'notizy_session_mode';
export const IDLE_TIMEOUT_MINUTES = 30;

const fallbackStorage: Storage = {
    getItem: () => null,
    setItem: () => undefined,
    removeItem: () => undefined,
    clear: () => undefined,
    key: () => null,
    length: 0
};

export const getSessionMode = (): SessionMode => {
    if (typeof window === 'undefined') {
        return DEFAULT_SESSION_MODE;
    }

    const stored = window.localStorage.getItem(SESSION_MODE_KEY);
    if (stored === 'idle_timeout' || stored === 'stay_logged_in' || stored === 'session_only') {
        return stored;
    }

    return DEFAULT_SESSION_MODE;
};

export const setSessionMode = (mode: SessionMode): void => {
    if (typeof window === 'undefined') {
        return;
    }

    window.localStorage.setItem(SESSION_MODE_KEY, mode);
};

export const getAuthStorage = (): Storage => {
    if (typeof window === 'undefined') {
        return fallbackStorage;
    }

    return getSessionMode() === 'session_only' ? window.sessionStorage : window.localStorage;
};

export const getIdleTimeoutMs = (): number => IDLE_TIMEOUT_MINUTES * 60 * 1000;
